import { Modal } from "antd";

export function confirmPublish(onPublish: () => void) {
  Modal.confirm({
    title: "Publish your changes?",
    content: "This updates your listing on all connected directories.",
    okText: "Publish",
    cancelText: "Cancel",
    onOk: onPublish,
  });
}
